import React, { useState, useEffect, useContext } from "react";
import { Calendar, Views } from "react-big-calendar";
import withDragAndDrop from "react-big-calendar/lib/addons/dragAndDrop";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-big-calendar/lib/addons/dragAndDrop/styles.css";
import { format, parse, startOfDay, endOfDay, startOfWeek, getDay, addDays, subDays, addMonths, subMonths, endOfWeek, startOfMonth, endOfMonth, } from "date-fns";
import { dateFnsLocalizer } from "react-big-calendar";
import { hideLoading, showLoading } from '../store/loadingSlice.js';
import axiosInstance from '../axiosConfig.js';
import Modal from "react-modal";
import axios from 'axios';
import "./Calendar.css";
import 'font-awesome/css/font-awesome.min.css';
import moment from 'moment';
import NavBar from "../Navbar/Navbar.js";
import Header from '../Header/Header.js';
import { useUser } from '../UserContext';
import { useDispatch, useSelector } from 'react-redux';
import Select from "react-select";

const locales = {
    "en-US": require("date-fns/locale/en-US"),
};

// Changed weekStartsOn to 1 (Monday)
const localizer = dateFnsLocalizer({
    format,
    parse,
    startOfWeek: () => startOfWeek(new Date(), { weekStartsOn: 1 }),
    getDay,
    locales,
});

// Define color mapping for actstates
const ACTSTATE_COLORS = {
    '1000': '#4285F4', // Blue
    '1001': '#0B8043', // Green
    '1002': '#8E24AA', // Purple
    '1003': '#D50000', // Red
    '1004': '#F4511E', // Orange
    '1005': '#E67C73', // Light Red
    '1006': '#039BE5', // Light Blue
    '1007': '#33B679', // Light Green
    '1008': '#7986CB', // Indigo
    '1009': '#616161', // Gray
    'default': '#ffffff' // Default blue
};

// Color name mapping for meetingcolor field
const COLOR_NAME_MAP = {
    'red': '#D50000',
    'green': '#0B8043',
    'blue': '#4285F4',
    'orange': '#F4511E',
    'purple': '#8E24AA',
    'gray': '#616161',
    'yellow': '#F9A825',
    'pink': '#E91E63',
    'teal': '#00ACC1',
    'default': '#ffffff'
};

const DnDCalendar = withDragAndDrop(Calendar);

const GoogleCalendar = () => {
    const [isNavOpen, setIsNavOpen] = useState(true);
    const { username, companyName } = useUser();

    const toggleNav = () => {
        setIsNavOpen(!isNavOpen);
    };


    const dispatch = useDispatch();

    // State for customer list and selected customer
    const [customers, setCustomers] = useState([]);
    const [isCustomerDropdownOpen, setIsCustomerDropdownOpen] = useState(false);
    const licenseData = useSelector((state) => state.liscence.modules);
    const staticData = useSelector(state => state.static.static);
    const [meetingData, setMeetingData] = useState([]);
    const initialValue = { start: new Date(), end: new Date() };
    const [dateRange, setDateRange] = useState(initialValue);

    const [actstates, setActstates] = useState([]);
    const [filteredActstates, setFilteredActstates] = useState([]);
    const [actstateSearchQuery, setActstateSearchQuery] = useState("");

    // Sample initial events
    const [events, setEvents] = useState([]);
    // Initialize current date to start of current week (Monday)
    const [currentDate, setCurrentDate] = useState(() => {
        const today = new Date();
        return window.innerWidth < 800 ? startOfDay(today) : startOfWeek(today, { weekStartsOn: 1 });
    });
    const [currentView, setCurrentView] = useState(window.innerWidth < 800 ? Views.DAY : Views.WEEK);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [customerSearchQuery, setCustomerSearchQuery] = useState("");
    const [filteredCustomers, setFilteredCustomers] = useState([]);
    //Select project - Modal(Action)
    const [projects, setProjects] = useState([]);
    const [filteredProjects, setFilteredProjects] = useState([]);
    const [projectSearchQuery, setProjectSearchQuery] = useState("");
    ////OBJECT DROPDOWN
    // const [crmObject, setcrmObject] = useState(0);
    // const taskTypeOptions = [
    //     { value: 0, label: "Γενικές Ενέργειες" },
    //     { value: 1, label: "Κλήση" },
    //     { value: 2, label: "Συνάντηση" },
    //     { value: 3, label: "Tasks" }
    // ];
    //Select Series - Modal(Action)
    const [series, setSeries] = useState([]);
    const [filteredSeries, setFilteredSeries] = useState([]);
    const [objectType, setObjectType] = useState('SOACTION');
    //Select User - Calendar
    const [activeActorId, setActiveActorId] = useState(staticData.actor);
    const defaultSeries=licenseData.default_series;
    const licenseIds=licenseData.CalendarUsers;
    const defaultState = licenseData.default_usestate;
    const [selectedLicenseOption, setSelectedLicenseOption] = useState(null);
    const [licenseOptions, setLicenseOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    //Select Users - Modal(Action)
    const [userOptions, setUserOptions] = useState([]);
    const [filteredUserOptions, setFilteredUserOptions] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]); // array of option objects
    const [userSearchQuery, setUserSearchQuery] = useState("");
    const [originalUserIds, setOriginalUserIds] = useState([]);


    // Function to determine object type based on SOREDIR value
    const getObjectType = (soredir) => {
        switch(soredir) {
            case '0': return 'SOACTION';
            case '1': return 'SOCALL';
            case '2': return 'SOMEETING';
            case '3': return 'SOTASK';
            default: return 'UNKNOWN';
        }
    };
    // Fetch captions for all license IDs
    useEffect(() => {
        const fetchAllCaptions = async () => {
          if (!licenseIds || !licenseIds.trim()) return;
          
          setIsLoading(true);
          const ids = licenseIds.split(',').map(id => id.trim());
          
          try {
            // Fetch captions for all IDs in parallel
            const captionPromises = ids.map(async (id) => {
              const caption = await fetchLicenseCaption(id);
              return {
                value: id,
                label: caption,
                originalId: id
              };
            });
      
            const options = await Promise.all(captionPromises);
            setLicenseOptions(options);
          } catch (error) {
            console.error('Error fetching license captions:', error);
            // Fallback: create options with just IDs
            setLicenseOptions(ids.map(id => ({
              value: id,
              label: `User not found`,
              originalId: id
            })));
          } finally {
            setIsLoading(false);
          }
        };
      
        fetchAllCaptions();
    }, [licenseIds]);

    // Set default selection after options are loaded
    useEffect(() => {
        if (licenseOptions.length > 0 && !selectedLicenseOption) {
          // Set the first option as default selected
          setSelectedLicenseOption(licenseOptions[0]);
          // Log the default selection to console
          //console.log('Default Selected License ID:', licenseOptions[0].value);
          setActiveActorId(licenseOptions[0].value ?? staticData.actor);
          //console.log('Active Calendar Actor:', activeActorId);
        }
    }, [licenseOptions, selectedLicenseOption]);

    // Handle selection change for single select
    const handleLicenseChange = (selectedOption) => {
        setSelectedLicenseOption(selectedOption);
        setActiveActorId(selectedOption?.value ?? staticData.actor);
        // Log the selected ID to console
        // if (selectedOption) {
        // console.log('Selected License ID:', selectedOption.value);
        // } else {
        // console.log('No license selected');
        // }
    };

      const fetchLicenseCaption = async (licenseId) => {
        try {
            const payload = {
                url: `https://${licenseData.company_url}/s1services`,
                service: "getData",
                clientID: localStorage.getItem("token"),
                appId: licenseData.appid,
                OBJECT: "USERS",
                LIST: "",
                VERSION: 2,
                KEY: licenseId, 
                LOCATEINFO: "USERS:CODE,NAME"
              };
              //console.log("fetch Caption: ",payload);
              const response = await axiosInstance.post("/api", payload);
              if (response.data.success) {
                return response.data.caption || `User not found`; 
              }else{
                console.error(`Error fetching caption for license ${licenseId}`);
                return `User not found`
              }
        } catch (error) {
          console.error(`Error fetching caption for license ${licenseId}:`, error);
          return `User not found`;
        }
      };

    const [formData, setFormData] = useState({
        id: null,
        //crmObject: "0", ////OBJECT DROPDOWN
        series: defaultSeries,
        seriesLabel: "",
        title: "",
        customerName: "",
        customerId: "",
        projectName: "", 
        projectId: "",    
        projectCode: "",  
        description: "",
        location: "",
        start: new Date(),
        end: new Date(),
        colorId: 0,
        actState: defaultState,
        meetingcolor: "blue", // Default color
    });

    const [showMiniMonth, setShowMiniMonth] = useState(true);
    const [customerList, setCustomerList] = useState([]);
    const today = format(new Date(), "dd/MM/yyyy");
    // customerOptions
    const customerOptions = customers.map((customer) => ({
        value: customer.trdr,
        label: customer.name,
    }));

    const filteredOptions = filteredCustomers.map((customer) => ({
        value: customer.trdr,
        label: customer.name,
    }));

    //PRJC Options
    const projectOptions = projects.map((project) => ({
        value: project.id,
        label: project.name
    }));
    
    const filteredProjectOptions = filteredProjects.map((project) => ({
        value: project.id,
        label: project.name
    }));

    const handleProjectChange = (selectedOption) => {
        setFormData(prev => ({
            ...prev,
            projectName: selectedOption?.label || "",
            projectId: selectedOption?.value || ""
        }));
    };

    //SERIES Options
    const seriesOptions = series.map((series) => ({
        value: series.series,
        label: series.seriesLabel
    }));
    
    const filteredSeriesOptions = filteredSeries.map((series) => ({
        value: series.series,
        label: series.seriesLabel
    }));

    const handleSeriesChange = (selectedOption) => {
        setFormData(prev => ({
            ...prev,
            series: selectedOption?.value || "",
            seriesLabel: selectedOption?.label || ""
        }));
    };
    

    // 🟢 This is called when selecting a customer
    const handleCustomerChange = (selectedOption) => {
        setFormData((prev) => ({
            ...prev,
            customerName: selectedOption?.label || "",
            customerId: selectedOption?.value || "",
        }));
    };

    // ❌ REMOVE the buggy useEffect that causes the loop — DO NOT add any useEffect for customerName update!

    // ✅ Fetch customers on mount
    useEffect(() => {
        getCustomers();
        fetchPRJC();
        fetchSERIES();
        fetchUsers();
    }, []);

    //on change of the series return the object of the series
    useEffect(() => {
        if (formData.series) {
            fetchSeriesInfo(formData.series);
        }
    }, [formData.series]);
    
    const fetchSeriesInfo = async (seriesValue) => {
        try {
            const payload = {
                url: `https://${licenseData.company_url}/s1services`,
                service: "getData",
                clientID: localStorage.getItem("token"),
                appId: licenseData.appid,
                OBJECT: "SERIES.2021",
                FORM:"",
                KEY: seriesValue, 
                LOCATEINFO: "SERIES:SOREDIR"
              };
              // ("fetch Caption: ",payload);
              const response = await axiosInstance.post("/api", payload);
              if (response.data.success) {
                const soredir = response.data.data.SERIES[0].SOREDIR; 
                const vObject = getObjectType(soredir);
                setObjectType(vObject);
              }else{
                console.error(`Error fetching caption for license ${seriesValue}`);
                return `User not found`
              }
        } catch (error) {
          console.error(`Error fetching caption for license ${seriesValue}:`, error);
          return `User not found`;
        }
      };


    // --- OBJECT DROPDOWN --- //
    // useEffect(() => {
    //     fetchSERIES();
    // }, [crmObject]);

    // const handleTaskTypeChange = (e) => {
    //     const newValue = parseInt(e.target.value);
    //     setSelectedTaskType(newValue);
    // };
    // --- ------------- --- //

    // Fetch customer list
    const getCustomers = async () => {
        try {
            dispatch(showLoading());

            const clientID = localStorage.getItem("token");
            const requestData = {
                url: `https://${licenseData.company_url}/s1services`,
                service: "SqlData",
                clientID,
                appId: licenseData.appid,
                SqlName: "9005",
                company: licenseData.company_id,
            };

            const response = await axiosInstance.post("/api", requestData);
            if (response?.data?.rows) {
                setCustomers(response.data.rows);
                setFilteredCustomers(response.data.rows);
            } else {
                console.error("Customer fetch error:", response.data?.message);
                setCustomers([]);
            }
        } catch (error) {
            console.error("Error fetching customers:", error);
            alert("Error fetching data");
        } finally {
            dispatch(hideLoading());
        }
    };

    const fetchPRJC = async () => {
        dispatch(showLoading());
        const parameters = {
            url: `https://${licenseData.company_url}/s1services`,
            service: "getBrowserInfo",
            clientID: localStorage.getItem("token"),
            appId: licenseData.appid,
            OBJECT: "PRJC",
            LIST: "",
            VERSION: 2,
            LIMIT: 1000,
            FILTERS:"PRJC.ISACTIVE=1"
        };
    
        try {
            const response = await axiosInstance.post("/api", parameters);
            const rows = response?.data?.rows || [];
            const projectData = rows.map(row => ({
                id: row[0].split(';')[1], // Extract ID after "PRJC;"
                name: row[3] || 'No Name'  // Project name only
            }));
    
            setProjects(projectData);
            setFilteredProjects(projectData);
        } catch (error) {
            console.error('Error fetching projects:', error);
            setProjects([]);
            setFilteredProjects([]);
        } finally {
            dispatch(hideLoading());
        }
    };

    const fetchSERIES = async () => {
        dispatch(showLoading());
        const parameters = {
            url: `https://${licenseData.company_url}/s1services`,
            service: "getBrowserInfo",
            clientID: localStorage.getItem("token"),
            appId: licenseData.appid,
            OBJECT: "SERIES",
            LIST: "",
            VERSION: 2,
            FILTERS:"SERIES.SOSOURCE=2021&SERIES.ISACTIVE=1", //&SERIES.SOREDIR=${crmObject}`, //OBJECT DROPDOWN
            LIMIT: 1000
        };
    
        try {
            const response = await axiosInstance.post("/api", parameters);
            const rows = response?.data?.rows || [];

            const seriesData = rows.map(row => ({
                series: row[0].split(';')[1],
                seriesLabel: `${row[0].split(';')[1]} - ${row[4]?.trim() ? row[4] : 'No Text'}`
            }));
    
            setSeries(seriesData);
            setFilteredSeries(seriesData);
        } catch (error) {
            console.error('Error fetching projects:', error);
            setSeries([]);
            setFilteredSeries([]);
        } finally {
            dispatch(hideLoading());
        }
    };

// ----------FILTER USERS FUNCTIONS-------------//
    const fetchUsers = async () => {
        dispatch(showLoading());
        try {
          const parameters = {
            url: `https://${licenseData.company_url}/s1services`,
            service: "getBrowserInfo",
            clientID: localStorage.getItem("token"),
            appId: licenseData.appid,
            OBJECT: "USERS",
            LIST: "",
            VERSION: 2,
            LIMIT: 1000,
            FILTERS: "USERS.ISACTIVE=1",
          };
      
          const response = await axiosInstance.post("/api", parameters);
          const rows = response?.data?.rows || [];
      
          // Map rows -> { value: row[2], label: `${row[2]} - ${row[4]}` }
          const mapped = rows
            .map((r) => {
              const v = r && r[2] ? String(r[2]).trim() : "";
              const caption = r && r[4] ? String(r[4]).trim() : "";
              if (!v) return null;
              return { value: v, label: `${v} - ${caption || v}` };
            })
            .filter(Boolean);
      
          setUserOptions(mapped);
          setFilteredUserOptions(mapped);
        } catch (err) {
          console.error("Error fetching users:", err);
        } finally {
          dispatch(hideLoading());
        }
    };

    useEffect(() => {
        if (!userSearchQuery) {
          setFilteredUserOptions(userOptions);
        } else {
          const q = userSearchQuery.toLowerCase();
          setFilteredUserOptions(userOptions.filter(o => o.label.toLowerCase().includes(q)));
        }
    }, [userSearchQuery, userOptions]);

    //Add helper
    const normalizeEventUsers = (event) => {
        if (!event) return [];
    
        let raw = event.vmusers;
    
        //console.log("🔵 normalizeEventUsers() raw vmusers:", raw, "type:", typeof raw);
    
        if (!raw) return [];
    
        // If it's a JSON string, try to parse it first
        if (typeof raw === "string") {
            // Try parse as JSON first: e.g. '[{"USERS":1},{"USERS":2}]'
            try {
                const parsed = JSON.parse(raw);
                if (Array.isArray(parsed)) {
                    raw = parsed;
                } else {
                    // Not an array, fall through to treat as comma-separated ids
                    throw new Error("not array");
                }
            } catch {
                // Treat as comma-separated ids: "1,2,3"
                const ids = raw
                    .split(",")
                    .map(s => s.trim())
                    .filter(Boolean);
    
                const output = ids.map(val => {
                    const opt = userOptions.find(o => String(o.value) === String(val));
                    return opt || { value: val, label: `${val}` };
                });
    
                //console.log("🔵 normalizeEventUsers() normalized from comma string:", output);
                return output;
            }
        }
    
        // If it's now an array (either from JSON or directly from SqlData)
        if (Array.isArray(raw)) {
            let ids;
    
            // Array of objects: [{ USERS: 1 }, { USERS: 2 }]
            if (raw.length && typeof raw[0] === "object") {
                ids = raw
                    .map(u => (u?.USERS != null ? String(u.USERS) : null))
                    .filter(Boolean);
            } else {
                // Array of ids: [1, 2, 3]
                ids = raw.map(v => String(v));
            }
    
            const output = ids.map(val => {
                const opt = userOptions.find(o => String(o.value) === String(val));
                return opt || { value: val, label: `${val}` };
            });
    
            //console.log("🔵 normalizeEventUsers() normalized from array:", output);
            return output;
        }
    
        //console.log("🔵 normalizeEventUsers() unhandled vmusers type, returning []");
        return [];
    };    
    //---------------------------------------------------------------//

    const getActstates = async () => {
        try {
            dispatch(showLoading());

            const clientID = localStorage.getItem("token");
            const companyID = localStorage.getItem("company");

            const requestData = {
                url: `https://${licenseData.company_url}/s1services`,
                service: "SqlData",
                clientID: clientID,
                appId: licenseData.appid,
                SqlName: "9007",
                company: licenseData.company_id
            };

            const response = await axiosInstance.post('/api', requestData);

            if (response && response.data) {
                setActstates(response.data.rows);
                setFilteredActstates(response.data.rows);
            } else {
                console.error("Error fetching actstates:", response.data?.message);
                setActstates([]);
                setFilteredActstates([]);
            }
        } catch (error) {
            console.error("Error fetching actstates:", error);
            alert("Error fetching data");
        } finally {
            dispatch(hideLoading());
        }
    };

    // Fetch actstates on component mount
    useEffect(() => {
        getActstates();
    }, []);

    // Filter actstates based on search query
    useEffect(() => {
        if (actstateSearchQuery) {
            const filtered = actstates.filter(actstate =>
                actstate.value.toLowerCase().includes(actstateSearchQuery.toLowerCase())
            );
            setFilteredActstates(filtered);
        } else {
            setFilteredActstates(actstates);
        }
    }, [actstateSearchQuery, actstates]);

    const formatDateForApi = (date) => {
        return format(date, "yyyy-MM-dd HH:mm:ss");
    };

    // Function to get event color based on actstate or meetingcolor
    const getEventColor = (event) => {
        // First priority: meetingcolor field
        if (event.meetingcolor) {
            return COLOR_NAME_MAP[event.meetingcolor.toLowerCase()] || COLOR_NAME_MAP.default;
        }

        // Second priority: actState mapping
        if (event.actState) {
            return ACTSTATE_COLORS[event.actState] || ACTSTATE_COLORS.default;
        }

        return ACTSTATE_COLORS.default;
    };

    const handleNavigate = (newDate, view) => {
        let start, end;

        // Determine the range based on current view (Changed to Monday start)
        if (view === Views.WEEK) {
            start = startOfWeek(newDate, { weekStartsOn: 1 }); // Monday
            end = endOfWeek(newDate, { weekStartsOn: 1 });
        } else if (view === Views.MONTH) {
            start = startOfMonth(newDate);
            end = endOfMonth(newDate);
        } else if (view === Views.DAY) {
            start = startOfDay(newDate);
            end = endOfDay(newDate);
        } else {
            // Default to week view if unknown
            start = startOfWeek(newDate, { weekStartsOn: 1 });
            end = endOfWeek(newDate, { weekStartsOn: 1 });
        }

        // Update the current date and view
        setCurrentDate(newDate);
        setCurrentView(view);

        // Update the date range state which will trigger the useEffect
        setDateRange({ start, end });
    };

    // This useEffect will automatically trigger fetchData when dateRange changes
    useEffect(() => {
        if (dateRange.start && dateRange.end) {
            fetchData();
        }
    }, [dateRange,activeActorId]);

    // Modified fetchData function to use the current dateRange
    const fetchData = async () => {
        dispatch(showLoading());
        try {
            const clientID = localStorage.getItem("token");
            const requestData = {
                url: `https://${licenseData.company_url}/s1services`,
                service: "SqlData",
                clientID,
                appId: licenseData.appid,
                actor: activeActorId,
                SqlName: "9102",
                company: licenseData.company_id,
                datefrom: format(dateRange.start, "yyyy-MM-dd"),
                dateto: format(dateRange.end, "yyyy-MM-dd"),
            };

            const response = await axiosInstance.post("/api", requestData);
            //console.log("Calendar Actions loaded:", response);
        
            if (response.data.success && response.data.rows) {
                const eventData = response.data.rows.map((item) => ({
                    id: item.soaction,
                    series: item.series,
                    seriesLabel: item.seriesLabel,
                    title: item.title || item.LabelField1 || "No Title",
                    start: new Date(`${item.fromdate}T${item.fromtime?.slice(0, 8) || '00:00:00'}`),
                    end: new Date(`${item.finaldate}T${item.finaltime?.slice(0, 8) || '00:00:00'}`),
                    customerName: item.customerName,
                    customerId: item.trdr,
                    projectName: item.projectName,
                    projectId: item.projectId,
                    description: item.remarks,
                    location: item.address,
                    phone: item.phone,
                    actState: item.actstates,
                    vmusers: item.vmusers,
                    meetingcolor: item.meetingcolor,
                    backgroundColor: getEventColor(item),
                }));
                setEvents(eventData);
            } else {
                setEvents([]);
            }
        } catch (error) {
            console.error("Error fetching meetings:", error);
            alert("Error fetching data");
        } finally {
            dispatch(hideLoading());
        }
    };

    useEffect(() => {
        const today = new Date();
        const initialStart = startOfWeek(today, { weekStartsOn: 1 }); // Changed to Monday
        const initialEnd = endOfWeek(today, { weekStartsOn: 1 });

        setDateRange({ start: initialStart, end: initialEnd });
    }, []);

    // Function to handle mini calendar date selection
    const handleMiniDateSelect = (selectedDate) => {
        if (currentView === Views.WEEK) {
            // Navigate to the week containing the selected date
            const weekStart = startOfWeek(selectedDate, { weekStartsOn: 1 }); // Changed to Monday
            setCurrentDate(weekStart);
        } else {
            setCurrentDate(selectedDate);
        }
    };

    const CustomToolbar = (toolbar) => {
        const goToToday = () => {
            const today = new Date();
            let targetDate = today;

            if (toolbar.view === Views.WEEK) {
                targetDate = startOfWeek(today, { weekStartsOn: 1 }); // Changed to Monday
            }

            toolbar.onNavigate('TODAY');
            setCurrentDate(targetDate);
        };

        const goToPrev = () => {
            toolbar.onNavigate('PREV');
        };

        const goToNext = () => {
            toolbar.onNavigate('NEXT');
        };

        // New function to handle view changes
        const handleViewChange = (newView) => {
            toolbar.onView(newView);

            // Update date range based on the new view and current date
            let start, end;
            const currentDate = toolbar.date || new Date();

            if (newView === Views.WEEK) {
                start = startOfWeek(currentDate, { weekStartsOn: 1 }); // Changed to Monday
                end = endOfWeek(currentDate, { weekStartsOn: 1 });
            } else if (newView === Views.MONTH) {
                start = startOfMonth(currentDate);
                end = endOfMonth(currentDate);
            } else if (newView === Views.DAY) {
                const today = new Date();
                toolbar.onNavigate('TODAY');
                start = startOfDay(today);
                end = endOfDay(today);           
            } else if (newView === Views.AGENDA) {
                // For agenda view, you might want to show a longer period
                // Let's show the current month for agenda
                start = startOfMonth(currentDate);
                end = endOfMonth(currentDate);
            } else {
                // Default to week view
                start = startOfWeek(currentDate, { weekStartsOn: 1 }); // Changed to Monday
                end = endOfWeek(currentDate, { weekStartsOn: 1 });
            }
            
            // Update the date range state which will trigger fetchData
            setDateRange({ start, end });
            setCurrentView(newView);
        };

        const getViewTitle = () => {
            const date = toolbar.date;
            if (toolbar.view === Views.MONTH) {
                return format(date, 'MMMM yyyy');
            } else if (toolbar.view === Views.WEEK) {
                const start = startOfWeek(date, { weekStartsOn: 1 }); // Changed to Monday
                const end = addDays(start, 6);
                return `${format(start, 'MMM d')} - ${format(end, 'MMM d, yyyy')}`;
            } else if (toolbar.view === Views.DAY) {
                return format(date, 'MMMM d, yyyy');
            }
            return format(date, 'MMMM yyyy');
        };

        return (
            <div className="calendar-toolbar">
                <div className="toolbar-left">
                    <button className="toolbar-button today-button" onClick={goToToday}>
                        Today
                    </button>
                    <div className="nav-buttons">
                        <button className="toolbar-button nav-button" onClick={goToPrev}>
                            <span>&#10094;</span>
                        </button>
                        <button className="toolbar-button nav-button" onClick={goToNext}>
                            <span>&#10095;</span>
                        </button>
                    </div>
                    <h2 className="toolbar-label">{getViewTitle()}</h2>
                </div>
                <div className="toolbar-right">
                    <button
                        className={`view-button ${toolbar.view === Views.DAY ? 'active' : ''}`}
                        onClick={() => handleViewChange(Views.DAY)}
                    >
                        Day
                    </button>
                    <button
                        className={`view-button ${toolbar.view === Views.WEEK ? 'active' : ''}`}
                        onClick={() => handleViewChange(Views.WEEK)}
                    >
                        Week
                    </button>
                    <button
                        className={`view-button ${toolbar.view === Views.MONTH ? 'active' : ''}`}
                        onClick={() => handleViewChange(Views.MONTH)}
                    >
                        Month
                    </button>
                    <button
                        className={`view-button ${toolbar.view === Views.AGENDA ? 'active' : ''}`}
                        onClick={() => handleViewChange(Views.AGENDA)}
                    >
                        Agenda
                    </button>
                </div>
            </div>
        );
    };

    // Enhanced EventComponent with color and meeting info
    const EventComponent = ({ event }) => {
        const eventColor = getEventColor(event);

        return (
            <div
                className="custom-event"
                style={{
                    backgroundColor: eventColor,
                    color: 'white',
                    padding: '2px 4px',
                    borderRadius: '3px',
                    fontSize: '12px',
                    overflow: 'hidden',
                    height: '100%',
                    border: `1px solid ${eventColor}`,
                    cursor: 'pointer'
                }}
            >
                <div className="event-title" style={{ fontWeight: 'bold', marginBottom: '1px' }}>
                    {event.title}
                </div>
                {event.customerName && (
                    <div className="event-customer" style={{ fontSize: '11px', opacity: 0.9 }}>
                        {event.customerName}
                    </div>
                )}
            </div>
        );
    };

    // Enhanced event style getter
    const eventStyleGetter = (event, start, end, isSelected) => {
        const backgroundColor = getEventColor(event);

        return {
            style: {
                backgroundColor,
                borderColor: backgroundColor,
                color: 'white',
                border: 'none',
                borderRadius: '3px',
                opacity: isSelected ? 0.8 : 1,
            }
        };
    };

const openModal = (event = null, { start, end } = {}) => {  
    if (event) {        
        setFormData({
            id: event.id,
            //crmObject: "", //OBJECT DROPDOWN
            series: event.series,
            seriesLabel: event.seriesLabel,
            title: event.title || "",
            customerName: event.customerName || "",
            customerId: event.customerId || event.trdr || "",
            projectName: event.projectName || "",
            projectId: event.projectId || "",
            description: event.description || "",
            location: event.location || "",
            start: event.start || new Date(),
            end: event.end || new Date(),
            colorId: event.colorId || 0,
            actState: event.actState || "",
            meetingcolor: event.meetingcolor || "blue",
            vmusers: event.vmusers || "",
            teams: event.teams || ""
        });
        setSelectedEvent(event);
        const normalized = normalizeEventUsers(event); 
        setSelectedUsers(normalized);
    } else {
        setFormData({
            id: null,
            //crmObject: "0", //OBJECT DROPDOWN
            series: defaultSeries,
            seriesLabel: "",
            title: "",
            customerName: "",
            customerId: "",
            projectName: "",
            projectId: "",
            description: "",
            location: "",
            start: start || new Date(),
            end: end || new Date(new Date().setHours(new Date().getHours() + 1)),
            colorId: 0,
            actState: defaultState,
            meetingcolor: "blue",
            vmusers: "",
            teams: ""
        });
        setSelectedEvent(null);
        setSelectedUsers([]); 
    }
    setModalOpen(true);
};

    const closeModal = () => {
        setModalOpen(false);
        setSelectedEvent(null);
        setIsCustomerDropdownOpen(false);
        setCustomerSearchQuery("");
    };



    const handleFormChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => {
            if (name === "customerName") {
                const selectedCustomer = customers.find(
                    (customer) => customer.NAME === value
                );
                return {
                    ...prev,
                    customerName: value,
                    customerId: selectedCustomer ? selectedCustomer.CODE : "",
                };
            }
            return { ...prev, [name]: value };
        });
    };


    const handleTimeChange = (isStart, e) => {
        const timeStr = e.target.value;
        const [hours, minutes] = timeStr.split(':').map(Number);

        const newDate = new Date(isStart ? formData.start : formData.end);
        newDate.setHours(hours);
        newDate.setMinutes(minutes);

        setFormData((prev) => ({
            ...prev,
            [isStart ? 'start' : 'end']: newDate
        }));
    };

    const handleDateChange = (isStart, e) => {
        const dateStr = e.target.value;
        const [year, month, day] = dateStr.split('-').map(Number);

        const newDate = new Date(isStart ? formData.start : formData.end);
        newDate.setFullYear(year);
        newDate.setMonth(month - 1);
        newDate.setDate(day);

        setFormData((prev) => ({
            ...prev,
            [isStart ? 'start' : 'end']: newDate
        }));
    };

    const handleCustomerSelect = (customer) => {
        setFormData((prev) => ({
            ...prev,
            customerName: customer.NAME,
            customerId: customer.CODE
        }));
        setIsCustomerDropdownOpen(false);
        setCustomerSearchQuery("");
    };

    const toggleCustomerDropdown = () => {
        setIsCustomerDropdownOpen(!isCustomerDropdownOpen);
    };

    const saveMeeting = async () => {
        if (!formData.title.trim()) {
            alert("Event title is required");
            return;
        }

        const clientID = localStorage.getItem("token");
        const now = new Date();

        const selectedUserIds = (selectedUsers || []).map(u => String(u.value));

        const requestBody = {
            url: `https://${licenseData.company_url}/s1services`,
            service: "setData",
            clientID: clientID,
            appId: licenseData.appid,
            OBJECT: objectType,
            KEY: formData.id || "",
            data: {
                "SOACTION": [{
                    VARCHAR01: formData.meetingcolor || "blue",
                    SERIES: formData.series,
                    TRNDATE: format(now, "yyyy-MM-dd HH:mm:ss"),
                    COMMENTS: formData.title,
                    REMARKS: formData.description || "",
                    TRDR: formData.customerId || "",
                    PRJC: formData.projectId || "",  
                    ACTOR: activeActorId,
                    FROMDATE: format(formData.start, "yyyy-MM-dd HH:mm:ss"),
                    FINALDATE: format(formData.end, "yyyy-MM-dd HH:mm:ss"),
                    ACTSTATES: formData.actState || "",
                    CCCXITTEAMS: formData.teams || ""
                }],
                VMTPRSN: selectedUserIds.length
                        ? selectedUserIds.map(uId => ({ USERS: uId }))
                        : []
            }
        };
        // console.log('selectedUserIds.length: '+selectedUserIds.length);
        // console.log('setData: '+JSON.stringify(requestBody, null, 2));
        try {
            dispatch(showLoading());
            const response = await axiosInstance.post("/api", requestBody);
            //console.log(response.data);
            if (response.data.success === false) {
                alert(`Save failed: ${response.data.error || "Unknown error"}`);
            }
            //alert("Event saved successfully!");
            await fetchData(); // Refresh calendar after save
            closeModal();
        } catch (error) {
            console.error("Save failed:", error);
            alert(`Save failed: ${error.message}`);
        }
        dispatch(hideLoading());
    };

    const deleteMeeting = async () => {
        if (!selectedEvent?.id) {
            alert("Cannot delete this event: Missing ID");
            return;
        }

        if (window.confirm("Are you sure you want to delete this event?")) {
            try {
                const clientID = localStorage.getItem("token");

                const requestBody = {
                    url: `https://${licenseData.company_url}/s1services`,
                    service: "delData",
                    clientID: clientID,
                    appId: licenseData.appid,
                    OBJECT: "SOACTION",
                    FORM: "",
                    KEY: selectedEvent.id
                };

                const response = await axiosInstance.post("/api", requestBody);
                //console.log("Delete Response:", response.data);

                if (response.data?.status === "success" || response.data?.success) {
                    //alert("Meeting deleted successfully!");
                    closeModal();
                    // Refresh the calendar data after successful deletion
                    await fetchData();
                } else {
                    alert("Error deleting meeting. Please try again.");
                }
            } catch (error) {
                console.error("Error deleting meeting:", error);
                alert("There was an error while deleting the meeting.");
            }
        }
    };

    const moveEvent = async ({ event, start, end }) => {
        const safeStart = start || event?.start || new Date();
        const safeEnd = end || event?.end || new Date();

        const updatedEvents = events.map((e) =>
            e.id === event.id ? { ...e, start: safeStart, end: safeEnd } : e
        );
        setEvents(updatedEvents);

        try {
            const clientID = localStorage.getItem("token");
            const requestBody = {
                url: `https://${licenseData.company_url}/s1services`,
                service: "setData",
                clientID: clientID,
                appId: licenseData.appid,
                OBJECT: "SOACTION",
                KEY: event.id,
                data: {
                    SOACTION: [{
                        FROMDATE: format(safeStart, "yyyy-MM-dd HH:mm:ss"),
                        FINALDATE: format(safeEnd, "yyyy-MM-dd HH:mm:ss"),
                    }]
                }
            };

            await axiosInstance.post("/api", requestBody);
            //console.log("Event moved successfully");
        } catch (error) {
            console.error("Error moving event:", error);
            setEvents(events);
            alert("Failed to update event. Please try again.");
        }
    };

    const resizeEvent = async ({ event, start, end }) => {
        // Update the event in state immediately for better UX
        const updatedEvents = events.map((e) =>
            e.id === event.id ? { ...e, start, end } : e
        );
        setEvents(updatedEvents);

        // Update the event in the backend
        try {
            const clientID = localStorage.getItem("token");
            const requestBody = {
                url: `https://${licenseData.company_url}/s1services`,
                service: "setData",
                clientID: clientID,
                appId: licenseData.appid,
                OBJECT: "SOACTION",
                KEY: event.id,
                data: {
                    SOACTION: [{
                        FROMDATE: format(start, "yyyy-MM-dd HH:mm:ss"),
                        FINALDATE: format(end, "yyyy-MM-dd HH:mm:ss"),
                    }]
                }
            };

            await axiosInstance.post("/api", requestBody);
            //console.log("Event resized successfully");
        } catch (error) {
            console.error("Error resizing event:", error);
            // Revert the change if API call fails
            setEvents(events);
            alert("Failed to update event. Please try again.");
        }
    };

    // Handle slot selection for adding new events
    const handleSelectSlot = ({ start, end }) => {
        openModal(null, { start, end });
    };

    const formatDateForInput = (date) => {
        if (!date || !(date instanceof Date) || isNaN(date.getTime())) {
            return '';
        }
        return date.toISOString().slice(0, 10);
    };

    const formatTimeForInput = (date) => {
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        return `${hours}:${minutes}`;
    };

    // Enhanced Mini month calendar component
    const MiniMonthCalendar = ({ date, onSelectDay }) => {
        const [miniDate, setMiniDate] = useState(date);

        useEffect(() => {
            setMiniDate(date);
        }, [date]);

        const firstDayOfMonth = new Date(miniDate.getFullYear(), miniDate.getMonth(), 1);
        const lastDayOfMonth = new Date(miniDate.getFullYear(), miniDate.getMonth() + 1, 0);
        const startCalendar = startOfWeek(firstDayOfMonth, { weekStartsOn: 0 });
        const endCalendar = endOfWeek(lastDayOfMonth, { weekStartsOn: 0 });

        const goToPrevMonth = () => {
            setMiniDate(subMonths(miniDate, 1));
        };

        const goToNextMonth = () => {
            setMiniDate(addMonths(miniDate, 1));
        };

        const handleDayClick = (day) => {
            onSelectDay(day);
        };

        const isCurrentMonth = (day) => {
            return day.getMonth() === miniDate.getMonth();
        };

        const isToday = (day) => {
            const today = new Date();
            return (
                day.getDate() === today.getDate() &&
                day.getMonth() === today.getMonth() &&
                day.getFullYear() === today.getFullYear()
            );
        };

        const isSelected = (day) => {
            return (
                day.getDate() === currentDate.getDate() &&
                day.getMonth() === currentDate.getMonth() &&
                day.getFullYear() === currentDate.getFullYear()
            );
        };

        const generateDays = () => {
            const days = [];
            let current = new Date(startCalendar);

            while (current <= endCalendar) {
                days.push(new Date(current));
                current.setDate(current.getDate() + 1);
            }

            return days.map((day, index) => (
                <div
                    key={index}
                    className={`mini-calendar-day ${!isCurrentMonth(day) ? 'other-month' : ''
                        } ${isToday(day) ? 'today' : ''} ${isSelected(day) ? 'selected' : ''
                        }`}
                    onClick={() => handleDayClick(day)}
                >
                    {day.getDate()}
                </div>
            ));
        };

        return (
            <div className="mini-calendar">
                <div className="mini-calendar-header">
                    <button className="mini-nav-btn" onClick={goToPrevMonth}>&#10094;</button>
                    <div className="mini-month-title">{format(miniDate, 'MMMM yyyy')}</div>
                    <button className="mini-nav-btn" onClick={goToNextMonth}>&#10095;</button>
                </div>
                <div className="mini-calendar-weekdays">
                    {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map((day) => (
                        <div key={day} className="mini-calendar-weekday">{day}</div>
                    ))}
                </div>
                <div className="mini-calendar-days">
                    {generateDays()}
                </div>
            </div>
        );
    };


    return (
        <div className="calendar-app-wrapper" style={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
            {/* Top Navbar */}
            <NavBar toggleNav={toggleNav} />

            {/* Header + Calendar Content */}
            <div className="calendar-content-container" style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0, overflow: 'hidden' }}>

                {/* Header */}
                <Header username={username} companyName={companyName} />

                {/* Calendar Page Title + Create Button */}
                <div
                    className="calendar-header"
                    style={{
                        padding: '16px 24px',
                        borderBottom: '1px solid #ddd',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexShrink: 0
                    }}
                >
                    <div className="calendar-title" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <h1 style={{ margin: 0, fontWeight: '700', fontSize: '1.5rem' }}>
                            <i className="fa fa-calendar" aria-hidden="true" /> My Calendar
                        </h1>
                    </div>
                    {/* Single User Select Dropdown */}
                    {licenseIds && licenseIds.trim() && (
                        <div className="single-user-select" style={{ 
                        minWidth:"20%",
                        marginRight: '10px',
                        display: "flex",
                        marginLeft:"auto",
                        alignItems:"center"
                        }}>
                        <label style={{ 
                            fontSize: '17px', 
                            fontWeight: 'bold', 
                            display: "flex",
                            gap:"5px",
                            alignItems:"center",
                            marginRight:"8px"
                        }}>
                            <i className="fa fa-user"></i> User:
                        </label>
                        
                        {isLoading ? (
                            <div style={{ 
                            padding: '10px', 
                            border: '1px solid #ccc', 
                            borderRadius: '8px',
                            backgroundColor: '#f9f9f9',
                            textAlign: 'center'
                            }}>
                            Loading User information...
                            </div>
                        ) : (
                            <Select
                            options={licenseOptions}
                            value={selectedLicenseOption}
                            onChange={handleLicenseChange}
                            placeholder="Select a User..."
                            isSearchable={true}
                            isLoading={isLoading}
                            styles={{
                                control: (base) => ({
                                ...base,
                                border: '1px solid #ccc',
                                borderRadius: '8px',
                                minHeight: '38px',
                                fontSize: '14px'
                                }),
                                menu: (base) => ({
                                ...base,
                                zIndex: 1000
                                }),
                                singleValue: (base) => ({
                                ...base,
                                color: '#1976d2',
                                fontWeight: 'normal',
                                fontSize: '14px'
                                })
                            }}
                            components={{
                                Option: ({ innerRef, innerProps, isSelected, isFocused, data }) => (
                                <div 
                                    ref={innerRef} 
                                    {...innerProps} 
                                    style={{
                                    padding: '8px 12px',
                                    backgroundColor: isSelected ? '#e3f2fd' : (isFocused ? '#f5f5f5' : 'white'),
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    fontSize: '14px'
                                    }}
                                >
                                    <input
                                    type="radio" // Changed from checkbox to radio for single select
                                    checked={isSelected}
                                    readOnly
                                    style={{ 
                                        marginRight: '8px',
                                        cursor: 'pointer'
                                    }}
                                    />
                                    {data.label}
                                </div>
                                )
                            }}
                            />
                        )}
                        </div>
                    )}

                    <button
                        className="create-button"
                        onClick={() => openModal()}
                        style={{ fontWeight: '600', cursor: 'pointer', padding: '8px 16px', fontSize: '1rem' }}
                    >
                        <span className="plus-icon" aria-hidden="true" style={{ fontSize: '1.2rem', marginRight: '6px' }}>+</span> Create
                    </button>
                </div>

                {/* Calendar Main Area */}
                <div className="calendar-content" style={{ flex: 1, display: 'flex', overflow: 'hidden', minHeight: 0 }}>
                    <div
                        className={`main-calendar ${showMiniMonth ? 'with-sidebar' : ''}`}
                        style={{ flex: 1, overflow: 'auto', minHeight: 0 }}
                    >
                        <DnDCalendar
                            localizer={localizer}
                            events={events}
                            startAccessor="start"
                            endAccessor="end"
                            view={currentView}
                            views={[Views.DAY, Views.WEEK, Views.MONTH, Views.AGENDA]}
                            date={currentDate}
                            onNavigate={handleNavigate}
                            onView={(view) => setCurrentView(view)}
                            onSelectEvent={openModal}
                            onSelectSlot={handleSelectSlot}
                            onEventDrop={moveEvent}
                            onEventResize={resizeEvent}
                            selectable
                            resizable
                            dragFromOutsideItem={null}
                            components={{
                                toolbar: CustomToolbar,
                                event: EventComponent,
                            }}
                            eventPropGetter={eventStyleGetter}
                            formats={{
                                timeGutterFormat: (date) => format(date, 'h a'),
                                dayFormat: (date) => format(date, 'EEE dd'),
                            }}
                            style={{ height: '100%' }}
                            step={15}
                            timeslots={4}
                        />
                    </div>
                </div>
            </div>

            {/* Modal */}
            {modalOpen && (
                <Modal
                    isOpen={modalOpen}
                    onRequestClose={closeModal}
                    ariaHideApp={false}
                    className="gcal-modal"
                    overlayClassName="gcal-modal-overlay"
                >
                    <div className="gcal-modal-header">
                        <h2>{formData?.id ? 'Edit event' : 'Add event'}</h2>
                        <button className="gcal-close-btn" onClick={closeModal} aria-label="Close modal">×</button>
                    </div>

                    <div className="gcal-modal-content">
                        {/* Title Input */}
                        <div className="gcal-form-group gcal-title-row">
                            <input
                                name="title"
                                value={formData?.title || ''}
                                onChange={handleFormChange}
                                placeholder="Add title"
                                className="gcal-title-input"
                                autoFocus
                                aria-label="Event title"
                            />
                        </div>

                        {/* Dropdown για Τύπο Ενέργειας */}
                        {/* <div className="form-group">
                            <label htmlFor="taskType">Τύπος Ενέργειας:</label>
                            <select
                            id="taskType"
                            value={selectedTaskType}
                            onChange={handleTaskTypeChange}
                            className="form-control"
                            style={{
                                padding: '8px 12px',
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                                fontSize: '14px',
                                backgroundColor: '#fff',
                                cursor: 'pointer'
                            }}
                            >
                            {taskTypeOptions.map(option => (
                                <option key={option.value} value={option.value}>
                                {option.label}
                                </option>
                            ))}
                            </select>
                        </div> */}

                        {/* Series Dropdown */}
                        <div className="gcal-form-group gcal-with-icon">
                            <div className="gcal-icon" aria-hidden="true">
                                <span className="gcal-material-icon">receipt_long</span>
                            </div>
                            {filteredSeriesOptions.length > 0 ? (
                                <Select
                                    options={filteredSeriesOptions}
                                    onChange={handleSeriesChange}
                                    value={seriesOptions.find(
                                        option => String(option.value) === String(formData.series)
                                    ) || null}
                                    placeholder="Select a serie..."
                                    className="gcal-select-container"
                                    classNamePrefix="gcal-select"
                                    isClearable
                                    noOptionsMessage={() => "No series found"}
                                />
                            ) : (
                                <div className="gcal-loading">Loading series...</div>
                            )}
                        </div>
                        
                        {/* Date & Time */}
                        <div className="gcal-form-group gcal-with-icon">
                            <div className="gcal-icon" aria-hidden="true">
                                <span className="gcal-material-icon">event</span>
                            </div>
                            <div className="gcal-date-time-inputs">
                                <div className="gcal-date-time-row">
                                    <input type="date" value={formData?.start ? formatDateForInput(formData.start) : ''} onChange={(e) => handleDateChange(true, e)} className="gcal-date-input" aria-label="Start date" />
                                    <input type="time" value={formData?.start ? formatTimeForInput(formData.start) : ''} onChange={(e) => handleTimeChange(true, e)} className="gcal-time-input" aria-label="Start time" />
                                </div>
                                <div className="gcal-date-time-row">
                                    <input type="date" value={formData?.end ? formatDateForInput(formData.end) : ''} onChange={(e) => handleDateChange(false, e)} className="gcal-date-input" aria-label="End date" />
                                    <input type="time" value={formData?.end ? formatTimeForInput(formData.end) : ''} onChange={(e) => handleTimeChange(false, e)} className="gcal-time-input" aria-label="End time" />
                                </div>
                            </div>
                        </div>

                        {/* Users Multi-select */}
                        <div className="gcal-form-group gcal-with-icon">
                        <div className="gcal-icon" aria-hidden="true">
                            <span className="gcal-material-icon">people</span>
                        </div>

                        {filteredUserOptions.length > 0 ? (
                            <Select
                            options={filteredUserOptions}
                            isMulti
                            onChange={(selected) => {
                                const vals = selected || [];
                                setSelectedUsers(vals);
                            }}
                            onInputChange={(inputValue) => setUserSearchQuery(inputValue)}
                            value={selectedUsers}
                            placeholder="Select users..."
                            className="gcal-select-container"
                            classNamePrefix="gcal-select"
                            isClearable
                            isDisabled={!!selectedEvent} 
                            noOptionsMessage={() => "No users found"}
                            />
                        ) : (
                            <div className="gcal-loading">Loading users...</div>
                        )}
                        </div>

                        {/* Location */}
                        <div className="gcal-form-group gcal-with-icon">
                            <div className="gcal-icon" aria-hidden="true">
                                <span className="gcal-material-icon">place</span>
                            </div>
                            <input name="location" value={formData?.location || ''} onChange={handleFormChange} placeholder="Add location" className="gcal-full-width-input" aria-label="Location" />
                        </div>

                        {/* Custommers */}
                        <div className="gcal-form-group gcal-with-icon">
                            <div className="gcal-icon" aria-hidden="true">
                                <span className="gcal-material-icon">person</span>
                            </div>
                            {filteredOptions.length > 0 ? (
                                <Select
                                    options={filteredOptions}
                                    onChange={handleCustomerChange}
                                    onInputChange={(inputValue) => setCustomerSearchQuery(inputValue)}
                                    value={
                                        filteredOptions.find(
                                            (option) => String(option.value) === String(formData?.customerId)
                                        ) ||
                                        customerOptions.find(
                                            (option) => String(option.value) === String(formData?.customerId)
                                        ) ||
                                        null
                                    }
                                    placeholder="Select a customer..."
                                    className="gcal-select-container"
                                    classNamePrefix="gcal-select"
                                    isClearable
                                />
                            ) : (
                                <div className="gcal-loading">Loading customers...</div>
                            )}
                        </div>
                        
                       {/* Projects Dropdown */}
                        <div className="gcal-form-group gcal-with-icon">
                            <div className="gcal-icon" aria-hidden="true">
                                <span className="gcal-material-icon">work</span>
                            </div>
                            {filteredProjectOptions.length > 0 ? (
                                <Select
                                    options={filteredProjectOptions}
                                    onChange={handleProjectChange}
                                    value={projectOptions.find(
                                        option => String(option.value) === String(formData.projectId)
                                    ) || null}
                                    placeholder="Select a project..."
                                    className="gcal-select-container"
                                    classNamePrefix="gcal-select"
                                    isClearable
                                    noOptionsMessage={() => "No projects found"}
                                />
                            ) : (
                                <div className="gcal-loading">Loading projects...</div>
                            )}
                        </div>

                        {/* Description */}
                        <div className="gcal-form-group gcal-with-icon">
                            <div className="gcal-icon" aria-hidden="true">
                                <span className="gcal-material-icon">description</span>
                            </div>
                            <textarea
                                name="description"
                                value={formData?.description || ''}
                                onChange={handleFormChange}
                                placeholder="Add description"
                                className="gcal-description-input"
                                rows={3}
                                aria-label="Description"
                            />
                        </div>

                        {/* Activity State */}
                        <div className="gcal-form-group gcal-with-icon">
                            <div className="gcal-icon" aria-hidden="true">
                                <span className="gcal-material-icon">flag</span>
                            </div>
                            <select
                                name="actState"
                                value={formData?.actState || ''}
                                onChange={handleFormChange}
                                className="gcal-full-width-input"
                                aria-label="Activity state"
                            >
                                <option value="">Select an activity state</option>
                                {filteredActstates && filteredActstates.map((actstate) => (
                                    <option key={actstate.key} value={actstate.key}>
                                        {actstate.value}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* Color Picker */}
                        <div className="gcal-form-group gcal-with-icon" style={{ alignItems: 'center' }}>
                            <div className="gcal-icon" aria-hidden="true">
                                <div className="gcal-color-icon"></div>
                            </div>
                            <div className="gcal-color-picker" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                {COLOR_NAME_MAP && Object.entries(COLOR_NAME_MAP).map(([colorName, hexCode]) => (
                                    <div
                                        key={colorName}
                                        title={colorName}
                                        style={{
                                            backgroundColor: hexCode,
                                            width: 24,
                                            height: 24,
                                            borderRadius: '50%',
                                            margin: 4,
                                            cursor: 'pointer',
                                            border: formData?.meetingcolor === colorName ? '3px solid #4285f4' : '2px solid #ccc',
                                            boxSizing: 'border-box',
                                        }}
                                        onClick={() => setFormData((prev) => ({ ...prev, meetingcolor: colorName }))}
                                        role="button"
                                        tabIndex={0}
                                        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') setFormData((prev) => ({ ...prev, meetingcolor: colorName })); }}
                                        aria-label={`Select color ${colorName}`}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Modal Footer */}
                    <div className="gcal-modal-footer" style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '12px',alignItems: 'center' }}>
                        {formData?.id && (
                            <button onClick={deleteMeeting} className="gcal-delete-btn" style={{ backgroundColor: '#e53935', color: 'white', border: 'none', padding: '8px 12px', borderRadius: '4px', cursor: 'pointer' }}>
                                Delete
                            </button>
                        )}
                        <div className="gcal-right-buttons" style={{ display: 'flex', gap: '12px' }}>
                            {/* Microsoft Teams Meeting Checkbox */}
                            <div className="teams-checkbox-container">
                                <label className="teams-checkbox-label">
                                    <input
                                    type="checkbox"
                                    checked={formData.teams === 1}
                                    onChange={(e) => {
                                        setFormData((prev) => ({
                                        ...prev,
                                        teams: e.target.checked ? 1 : 0,
                                        }));
                                    }}
                                    className="teams-checkbox-input"
                                    />
                                    <span className="teams-checkbox-custom">
                                        <span className="teams-checkbox-logo">
                                            <img
                                            src="/microsoftTeams.png"
                                            alt="Microsoft Teams"
                                            width="24"
                                            height="24"
                                            />
                                        </span>
                                        <span className="teams-checkbox-text">Open Teams Meeting</span>
                                        <span className="teams-checkbox-toggle">
                                            <span className="teams-checkbox-toggle-circle"></span>
                                        </span>
                                    </span>
                                </label>
                            </div>
                            <div className="gcal-right-buttons2" style={{ display: 'flex', gap: '12px' }}>
                                <button className="gcal-cancel-btn" onClick={closeModal} style={{ padding: '8px 16px', cursor: 'pointer' }}>
                                    Cancel
                                </button>
                                <button
                                    className="gcal-save-btn"
                                    onClick={saveMeeting}
                                    disabled={!formData?.title?.trim()}
                                    style={{
                                        backgroundColor: formData?.title?.trim() ? '#4285f4' : '#a3c0f9',
                                        border: 'none',
                                        padding: '8px 16px',
                                        borderRadius: '4px',
                                        color: 'white',
                                        cursor: formData?.title?.trim() ? 'pointer' : 'not-allowed',
                                    }}
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>
            )}
        </div>
    );
};

export default GoogleCalendar;
